var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-wrapper"}},[_c('top-nav'),_c('site-header'),_c('main',{staticClass:"content"},[_c('div',{staticClass:"layout-content"},[_c('router-view')],1)]),_c('chat-genesys'),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }